import { Component, OnInit } from '@angular/core';
import { HelperService } from 'src/app/services/Helper/helper.service';
import { LookupService } from 'src/app/services/Lookup/lookup.service';
import { ProviderParameters, CurrencyParameters, TimezoneParameters } from 'src/app/models/ui/ProviderParameters';
import { RegistrationService } from 'src/app/services/registration.service';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

  constructor(private helper: HelperService, private lookupService: LookupService, private registrationService: RegistrationService) { 
    this.provider = new ProviderParameters();
  }

  isAuthorized: string;

  provider: ProviderParameters;

  currencyList: any[];
  timezoneList: any[];

  selectedCurrency: CurrencyParameters;
  selectedTimezone: TimezoneParameters;
  
  ngOnInit() {
    this.isAuthorized = localStorage.getItem("isAuthorized");

    if(this.isAuthorized === "true") {
    this.helper.setTitle('Provider - Settings');

    this.lookupService.getProvider().subscribe(data => this.provider = data);

    this.lookupService.getCurrencies().subscribe(data => this.currencyList = data);
    this.lookupService.getTimezones().subscribe(data => this.timezoneList = data);
    }
    else
    location.assign("#/login-form");
  }

  changeCurrency(e) {
    this.selectedCurrency = e.value;
  }

  changeTimezone(e) {
    this.selectedTimezone = e.value;
  }

  submitChanges(e) {
    this.provider.CurrencyId = this.selectedCurrency.Id;
    this.provider.TimezoneId = this.selectedTimezone.Id;
    
    this.registrationService.updateProvider(this.provider).subscribe(data => alert(data));
  }
}